export const dataBySlug = {
    "andorra": {
        "country": "AD",
        "latitude": 42.546245,
        "longitude": 1.601554,
        "name": "Andorra",
        "iso2": "AD",
        "slug": "andorra"
    },
    "united-arab-emirates": {
        "country": "AE",
        "latitude": 23.424076,
        "longitude": 53.847818,
        "name": "United Arab Emirates",
        "iso2": "AE",
        "slug": "united-arab-emirates"
    },
    "afghanistan": {
        "country": "AF",
        "latitude": 33.93911,
        "longitude": 67.709953,
        "name": "Afghanistan",
        "iso2": "AF",
        "slug": "afghanistan"
    },
    "antigua-and-barbuda": {
        "country": "AG",
        "latitude": 17.060816,
        "longitude": -61.796428,
        "name": "Antigua and Barbuda",
        "iso2": "AG",
        "slug": "antigua-and-barbuda"
    },
    "anguilla": {
        "country": "AI",
        "latitude": 18.220554,
        "longitude": -63.068615,
        "name": "Anguilla",
        "iso2": "AI",
        "slug": "anguilla"
    },
    "albania": {
        "country": "AL",
        "latitude": 41.153332,
        "longitude": 20.168331,
        "name": "Albania",
        "iso2": "AL",
        "slug": "albania"
    },
    "armenia": {
        "country": "AM",
        "latitude": 40.069099,
        "longitude": 45.038189,
        "name": "Armenia",
        "iso2": "AM",
        "slug": "armenia"
    },
    "netherlands-antilles": {
        "country": "AN",
        "latitude": 12.226079,
        "longitude": -69.060087,
        "name": "Netherlands Antilles",
        "iso2": "AN",
        "slug": "netherlands-antilles"
    },
    "angola": {
        "country": "AO",
        "latitude": -11.202692,
        "longitude": 17.873887,
        "name": "Angola",
        "iso2": "AO",
        "slug": "angola"
    },
    "antarctica": {
        "country": "AQ",
        "latitude": -75.250973,
        "longitude": -0.071389,
        "name": "Antarctica",
        "iso2": "AQ",
        "slug": "antarctica"
    },
    "argentina": {
        "country": "AR",
        "latitude": -38.416097,
        "longitude": -63.616672,
        "name": "Argentina",
        "iso2": "AR",
        "slug": "argentina"
    },
    "american-samoa": {
        "country": "AS",
        "latitude": -14.270972,
        "longitude": -170.132217,
        "name": "American Samoa",
        "iso2": "AS",
        "slug": "american-samoa"
    },
    "austria": {
        "country": "AT",
        "latitude": 47.516231,
        "longitude": 14.550072,
        "name": "Austria",
        "iso2": "AT",
        "slug": "austria"
    },
    "australia": {
        "country": "AU",
        "latitude": -25.274398,
        "longitude": 133.775136,
        "name": "Australia",
        "iso2": "AU",
        "slug": "australia"
    },
    "aruba": {
        "country": "AW",
        "latitude": 12.52111,
        "longitude": -69.968338,
        "name": "Aruba",
        "iso2": "AW",
        "slug": "aruba"
    },
    "azerbaijan": {
        "country": "AZ",
        "latitude": 40.143105,
        "longitude": 47.576927,
        "name": "Azerbaijan",
        "iso2": "AZ",
        "slug": "azerbaijan"
    },
    "bosnia-and-herzegovina": {
        "country": "BA",
        "latitude": 43.915886,
        "longitude": 17.679076,
        "name": "Bosnia and Herzegovina",
        "iso2": "BA",
        "slug": "bosnia-and-herzegovina"
    },
    "barbados": {
        "country": "BB",
        "latitude": 13.193887,
        "longitude": -59.543198,
        "name": "Barbados",
        "iso2": "BB",
        "slug": "barbados"
    },
    "bangladesh": {
        "country": "BD",
        "latitude": 23.684994,
        "longitude": 90.356331,
        "name": "Bangladesh",
        "iso2": "BD",
        "slug": "bangladesh"
    },
    "belgium": {
        "country": "BE",
        "latitude": 50.503887,
        "longitude": 4.469936,
        "name": "Belgium",
        "iso2": "BE",
        "slug": "belgium"
    },
    "burkina-faso": {
        "country": "BF",
        "latitude": 12.238333,
        "longitude": -1.561593,
        "name": "Burkina Faso",
        "iso2": "BF",
        "slug": "burkina-faso"
    },
    "bulgaria": {
        "country": "BG",
        "latitude": 42.733883,
        "longitude": 25.48583,
        "name": "Bulgaria",
        "iso2": "BG",
        "slug": "bulgaria"
    },
    "bahrain": {
        "country": "BH",
        "latitude": 25.930414,
        "longitude": 50.637772,
        "name": "Bahrain",
        "iso2": "BH",
        "slug": "bahrain"
    },
    "burundi": {
        "country": "BI",
        "latitude": -3.373056,
        "longitude": 29.918886,
        "name": "Burundi",
        "iso2": "BI",
        "slug": "burundi"
    },
    "benin": {
        "country": "BJ",
        "latitude": 9.30769,
        "longitude": 2.315834,
        "name": "Benin",
        "iso2": "BJ",
        "slug": "benin"
    },
    "bermuda": {
        "country": "BM",
        "latitude": 32.321384,
        "longitude": -64.75737,
        "name": "Bermuda",
        "iso2": "BM",
        "slug": "bermuda"
    },
    "brunei": {
        "country": "BN",
        "latitude": 4.535277,
        "longitude": 114.727669,
        "name": "Brunei",
        "iso2": "BN",
        "slug": "brunei"
    },
    "bolivia": {
        "country": "BO",
        "latitude": -16.290154,
        "longitude": -63.588653,
        "name": "Bolivia",
        "iso2": "BO",
        "slug": "bolivia"
    },
    "brazil": {
        "country": "BR",
        "latitude": -14.235004,
        "longitude": -51.92528,
        "name": "Brazil",
        "iso2": "BR",
        "slug": "brazil"
    },
    "bahamas": {
        "country": "BS",
        "latitude": 25.03428,
        "longitude": -77.39628,
        "name": "Bahamas",
        "iso2": "BS",
        "slug": "bahamas"
    },
    "bhutan": {
        "country": "BT",
        "latitude": 27.514162,
        "longitude": 90.433601,
        "name": "Bhutan",
        "iso2": "BT",
        "slug": "bhutan"
    },
    "bouvet-island": {
        "country": "BV",
        "latitude": -54.423199,
        "longitude": 3.413194,
        "name": "Bouvet Island",
        "iso2": "BV",
        "slug": "bouvet-island"
    },
    "botswana": {
        "country": "BW",
        "latitude": -22.328474,
        "longitude": 24.684866,
        "name": "Botswana",
        "iso2": "BW",
        "slug": "botswana"
    },
    "belarus": {
        "country": "BY",
        "latitude": 53.709807,
        "longitude": 27.953389,
        "name": "Belarus",
        "iso2": "BY",
        "slug": "belarus"
    },
    "belize": {
        "country": "BZ",
        "latitude": 17.189877,
        "longitude": -88.49765,
        "name": "Belize",
        "iso2": "BZ",
        "slug": "belize"
    },
    "canada": {
        "country": "CA",
        "latitude": 56.130366,
        "longitude": -106.346771,
        "name": "Canada",
        "iso2": "CA",
        "slug": "canada"
    },
    "cocos-keeling-islands": {
        "country": "CC",
        "latitude": -12.164165,
        "longitude": 96.870956,
        "name": "Cocos [Keeling] Islands",
        "iso2": "CC",
        "slug": "cocos-keeling-islands"
    },
    "congo-kinshasa": {
        "country": "CD",
        "latitude": -4.038333,
        "longitude": 21.758664,
        "name": "Congo [DRC]",
        "iso2": "CD",
        "slug": "congo-kinshasa"
    },
    "central-african-republic": {
        "country": "CF",
        "latitude": 6.611111,
        "longitude": 20.939444,
        "name": "Central African Republic",
        "iso2": "CF",
        "slug": "central-african-republic"
    },
    "congo-brazzaville": {
        "country": "CG",
        "latitude": -0.228021,
        "longitude": 15.827659,
        "name": "Congo [Republic]",
        "iso2": "CG",
        "slug": "congo-brazzaville"
    },
    "switzerland": {
        "country": "CH",
        "latitude": 46.818188,
        "longitude": 8.227512,
        "name": "Switzerland",
        "iso2": "CH",
        "slug": "switzerland"
    },
    "cote-divoire": {
        "country": "CI",
        "latitude": 7.539989,
        "longitude": -5.54708,
        "name": "Côte d'Ivoire",
        "iso2": "CI",
        "slug": "cote-divoire"
    },
    "cook-islands": {
        "country": "CK",
        "latitude": -21.236736,
        "longitude": -159.777671,
        "name": "Cook Islands",
        "iso2": "CK",
        "slug": "cook-islands"
    },
    "chile": {
        "country": "CL",
        "latitude": -35.675147,
        "longitude": -71.542969,
        "name": "Chile",
        "iso2": "CL",
        "slug": "chile"
    },
    "cameroon": {
        "country": "CM",
        "latitude": 7.369722,
        "longitude": 12.354722,
        "name": "Cameroon",
        "iso2": "CM",
        "slug": "cameroon"
    },
    "china": {
        "country": "CN",
        "latitude": 35.86166,
        "longitude": 104.195397,
        "name": "China",
        "iso2": "CN",
        "slug": "china"
    },
    "colombia": {
        "country": "CO",
        "latitude": 4.570868,
        "longitude": -74.297333,
        "name": "Colombia",
        "iso2": "CO",
        "slug": "colombia"
    },
    "costa-rica": {
        "country": "CR",
        "latitude": 9.748917,
        "longitude": -83.753428,
        "name": "Costa Rica",
        "iso2": "CR",
        "slug": "costa-rica"
    },
    "cuba": {
        "country": "CU",
        "latitude": 21.521757,
        "longitude": -77.781167,
        "name": "Cuba",
        "iso2": "CU",
        "slug": "cuba"
    },
    "cape-verde": {
        "country": "CV",
        "latitude": 16.002082,
        "longitude": -24.013197,
        "name": "Cape Verde",
        "iso2": "CV",
        "slug": "cape-verde"
    },
    "christmas-island": {
        "country": "CX",
        "latitude": -10.447525,
        "longitude": 105.690449,
        "name": "Christmas Island",
        "iso2": "CX",
        "slug": "christmas-island"
    },
    "cyprus": {
        "country": "CY",
        "latitude": 35.126413,
        "longitude": 33.429859,
        "name": "Cyprus",
        "iso2": "CY",
        "slug": "cyprus"
    },
    "czech-republic": {
        "country": "CZ",
        "latitude": 49.817492,
        "longitude": 15.472962,
        "name": "Czech Republic",
        "iso2": "CZ",
        "slug": "czech-republic"
    },
    "germany": {
        "country": "DE",
        "latitude": 51.165691,
        "longitude": 10.451526,
        "name": "Germany",
        "iso2": "DE",
        "slug": "germany"
    },
    "djibouti": {
        "country": "DJ",
        "latitude": 11.825138,
        "longitude": 42.590275,
        "name": "Djibouti",
        "iso2": "DJ",
        "slug": "djibouti"
    },
    "denmark": {
        "country": "DK",
        "latitude": 56.26392,
        "longitude": 9.501785,
        "name": "Denmark",
        "iso2": "DK",
        "slug": "denmark"
    },
    "dominica": {
        "country": "DM",
        "latitude": 15.414999,
        "longitude": -61.370976,
        "name": "Dominica",
        "iso2": "DM",
        "slug": "dominica"
    },
    "dominican-republic": {
        "country": "DO",
        "latitude": 18.735693,
        "longitude": -70.162651,
        "name": "Dominican Republic",
        "iso2": "DO",
        "slug": "dominican-republic"
    },
    "algeria": {
        "country": "DZ",
        "latitude": 28.033886,
        "longitude": 1.659626,
        "name": "Algeria",
        "iso2": "DZ",
        "slug": "algeria"
    },
    "ecuador": {
        "country": "EC",
        "latitude": -1.831239,
        "longitude": -78.183406,
        "name": "Ecuador",
        "iso2": "EC",
        "slug": "ecuador"
    },
    "estonia": {
        "country": "EE",
        "latitude": 58.595272,
        "longitude": 25.013607,
        "name": "Estonia",
        "iso2": "EE",
        "slug": "estonia"
    },
    "egypt": {
        "country": "EG",
        "latitude": 26.820553,
        "longitude": 30.802498,
        "name": "Egypt",
        "iso2": "EG",
        "slug": "egypt"
    },
    "western-sahara": {
        "country": "EH",
        "latitude": 24.215527,
        "longitude": -12.885834,
        "name": "Western Sahara",
        "iso2": "EH",
        "slug": "western-sahara"
    },
    "eritrea": {
        "country": "ER",
        "latitude": 15.179384,
        "longitude": 39.782334,
        "name": "Eritrea",
        "iso2": "ER",
        "slug": "eritrea"
    },
    "spain": {
        "country": "ES",
        "latitude": 40.463667,
        "longitude": -3.74922,
        "name": "Spain",
        "iso2": "ES",
        "slug": "spain"
    },
    "ethiopia": {
        "country": "ET",
        "latitude": 9.145,
        "longitude": 40.489673,
        "name": "Ethiopia",
        "iso2": "ET",
        "slug": "ethiopia"
    },
    "finland": {
        "country": "FI",
        "latitude": 61.92411,
        "longitude": 25.748151,
        "name": "Finland",
        "iso2": "FI",
        "slug": "finland"
    },
    "fiji": {
        "country": "FJ",
        "latitude": -16.578193,
        "longitude": 179.414413,
        "name": "Fiji",
        "iso2": "FJ",
        "slug": "fiji"
    },
    "falkland-islands-malvinas": {
        "country": "FK",
        "latitude": -51.796253,
        "longitude": -59.523613,
        "name": "Falkland Islands [Islas Malvinas]",
        "iso2": "FK",
        "slug": "falkland-islands-malvinas"
    },
    "micronesia": {
        "country": "FM",
        "latitude": 7.425554,
        "longitude": 150.550812,
        "name": "Micronesia",
        "iso2": "FM",
        "slug": "micronesia"
    },
    "faroe-islands": {
        "country": "FO",
        "latitude": 61.892635,
        "longitude": -6.911806,
        "name": "Faroe Islands",
        "iso2": "FO",
        "slug": "faroe-islands"
    },
    "france": {
        "country": "FR",
        "latitude": 46.227638,
        "longitude": 2.213749,
        "name": "France",
        "iso2": "FR",
        "slug": "france"
    },
    "gabon": {
        "country": "GA",
        "latitude": -0.803689,
        "longitude": 11.609444,
        "name": "Gabon",
        "iso2": "GA",
        "slug": "gabon"
    },
    "united-kingdom": {
        "country": "GB",
        "latitude": 55.378051,
        "longitude": -3.435973,
        "name": "United Kingdom",
        "iso2": "GB",
        "slug": "united-kingdom"
    },
    "grenada": {
        "country": "GD",
        "latitude": 12.262776,
        "longitude": -61.604171,
        "name": "Grenada",
        "iso2": "GD",
        "slug": "grenada"
    },
    "georgia": {
        "country": "GE",
        "latitude": 42.315407,
        "longitude": 43.356892,
        "name": "Georgia",
        "iso2": "GE",
        "slug": "georgia"
    },
    "french-guiana": {
        "country": "GF",
        "latitude": 3.933889,
        "longitude": -53.125782,
        "name": "French Guiana",
        "iso2": "GF",
        "slug": "french-guiana"
    },
    "guernsey": {
        "country": "GG",
        "latitude": 49.465691,
        "longitude": -2.585278,
        "name": "Guernsey",
        "iso2": "GG",
        "slug": "guernsey"
    },
    "ghana": {
        "country": "GH",
        "latitude": 7.946527,
        "longitude": -1.023194,
        "name": "Ghana",
        "iso2": "GH",
        "slug": "ghana"
    },
    "gibraltar": {
        "country": "GI",
        "latitude": 36.137741,
        "longitude": -5.345374,
        "name": "Gibraltar",
        "iso2": "GI",
        "slug": "gibraltar"
    },
    "greenland": {
        "country": "GL",
        "latitude": 71.706936,
        "longitude": -42.604303,
        "name": "Greenland",
        "iso2": "GL",
        "slug": "greenland"
    },
    "gambia": {
        "country": "GM",
        "latitude": 13.443182,
        "longitude": -15.310139,
        "name": "Gambia",
        "iso2": "GM",
        "slug": "gambia"
    },
    "guinea": {
        "country": "GN",
        "latitude": 9.945587,
        "longitude": -9.696645,
        "name": "Guinea",
        "iso2": "GN",
        "slug": "guinea"
    },
    "guadeloupe": {
        "country": "GP",
        "latitude": 16.995971,
        "longitude": -62.067641,
        "name": "Guadeloupe",
        "iso2": "GP",
        "slug": "guadeloupe"
    },
    "equatorial-guinea": {
        "country": "GQ",
        "latitude": 1.650801,
        "longitude": 10.267895,
        "name": "Equatorial Guinea",
        "iso2": "GQ",
        "slug": "equatorial-guinea"
    },
    "greece": {
        "country": "GR",
        "latitude": 39.074208,
        "longitude": 21.824312,
        "name": "Greece",
        "iso2": "GR",
        "slug": "greece"
    },
    "south-georgia-and-the-south-sandwich-islands": {
        "country": "GS",
        "latitude": -54.429579,
        "longitude": -36.587909,
        "name": "South Georgia and the South Sandwich Islands",
        "iso2": "GS",
        "slug": "south-georgia-and-the-south-sandwich-islands"
    },
    "guatemala": {
        "country": "GT",
        "latitude": 15.783471,
        "longitude": -90.230759,
        "name": "Guatemala",
        "iso2": "GT",
        "slug": "guatemala"
    },
    "guam": {
        "country": "GU",
        "latitude": 13.444304,
        "longitude": 144.793731,
        "name": "Guam",
        "iso2": "GU",
        "slug": "guam"
    },
    "guinea-bissau": {
        "country": "GW",
        "latitude": 11.803749,
        "longitude": -15.180413,
        "name": "Guinea-Bissau",
        "iso2": "GW",
        "slug": "guinea-bissau"
    },
    "guyana": {
        "country": "GY",
        "latitude": 4.860416,
        "longitude": -58.93018,
        "name": "Guyana",
        "iso2": "GY",
        "slug": "guyana"
    },
    "hong-kong-sar-china": {
        "country": "HK",
        "latitude": 22.396428,
        "longitude": 114.109497,
        "name": "Hong Kong",
        "iso2": "HK",
        "slug": "hong-kong-sar-china"
    },
    "heard-and-mcdonald-islands": {
        "country": "HM",
        "latitude": -53.08181,
        "longitude": 73.504158,
        "name": "Heard Island and McDonald Islands",
        "iso2": "HM",
        "slug": "heard-and-mcdonald-islands"
    },
    "honduras": {
        "country": "HN",
        "latitude": 15.199999,
        "longitude": -86.241905,
        "name": "Honduras",
        "iso2": "HN",
        "slug": "honduras"
    },
    "croatia": {
        "country": "HR",
        "latitude": 45.1,
        "longitude": 15.2,
        "name": "Croatia",
        "iso2": "HR",
        "slug": "croatia"
    },
    "haiti": {
        "country": "HT",
        "latitude": 18.971187,
        "longitude": -72.285215,
        "name": "Haiti",
        "iso2": "HT",
        "slug": "haiti"
    },
    "hungary": {
        "country": "HU",
        "latitude": 47.162494,
        "longitude": 19.503304,
        "name": "Hungary",
        "iso2": "HU",
        "slug": "hungary"
    },
    "indonesia": {
        "country": "ID",
        "latitude": -0.789275,
        "longitude": 113.921327,
        "name": "Indonesia",
        "iso2": "ID",
        "slug": "indonesia"
    },
    "ireland": {
        "country": "IE",
        "latitude": 53.41291,
        "longitude": -8.24389,
        "name": "Ireland",
        "iso2": "IE",
        "slug": "ireland"
    },
    "israel": {
        "country": "IL",
        "latitude": 31.046051,
        "longitude": 34.851612,
        "name": "Israel",
        "iso2": "IL",
        "slug": "israel"
    },
    "isle-of-man": {
        "country": "IM",
        "latitude": 54.236107,
        "longitude": -4.548056,
        "name": "Isle of Man",
        "iso2": "IM",
        "slug": "isle-of-man"
    },
    "india": {
        "country": "IN",
        "latitude": 20.593684,
        "longitude": 78.96288,
        "name": "India",
        "iso2": "IN",
        "slug": "india"
    },
    "british-indian-ocean-territory": {
        "country": "IO",
        "latitude": -6.343194,
        "longitude": 71.876519,
        "name": "British Indian Ocean Territory",
        "iso2": "IO",
        "slug": "british-indian-ocean-territory"
    },
    "iraq": {
        "country": "IQ",
        "latitude": 33.223191,
        "longitude": 43.679291,
        "name": "Iraq",
        "iso2": "IQ",
        "slug": "iraq"
    },
    "iran": {
        "country": "IR",
        "latitude": 32.427908,
        "longitude": 53.688046,
        "name": "Iran",
        "iso2": "IR",
        "slug": "iran"
    },
    "iceland": {
        "country": "IS",
        "latitude": 64.963051,
        "longitude": -19.020835,
        "name": "Iceland",
        "iso2": "IS",
        "slug": "iceland"
    },
    "italy": {
        "country": "IT",
        "latitude": 41.87194,
        "longitude": 12.56738,
        "name": "Italy",
        "iso2": "IT",
        "slug": "italy"
    },
    "jersey": {
        "country": "JE",
        "latitude": 49.214439,
        "longitude": -2.13125,
        "name": "Jersey",
        "iso2": "JE",
        "slug": "jersey"
    },
    "jamaica": {
        "country": "JM",
        "latitude": 18.109581,
        "longitude": -77.297508,
        "name": "Jamaica",
        "iso2": "JM",
        "slug": "jamaica"
    },
    "jordan": {
        "country": "JO",
        "latitude": 30.585164,
        "longitude": 36.238414,
        "name": "Jordan",
        "iso2": "JO",
        "slug": "jordan"
    },
    "japan": {
        "country": "JP",
        "latitude": 36.204824,
        "longitude": 138.252924,
        "name": "Japan",
        "iso2": "JP",
        "slug": "japan"
    },
    "kenya": {
        "country": "KE",
        "latitude": -0.023559,
        "longitude": 37.906193,
        "name": "Kenya",
        "iso2": "KE",
        "slug": "kenya"
    },
    "kyrgyzstan": {
        "country": "KG",
        "latitude": 41.20438,
        "longitude": 74.766098,
        "name": "Kyrgyzstan",
        "iso2": "KG",
        "slug": "kyrgyzstan"
    },
    "cambodia": {
        "country": "KH",
        "latitude": 12.565679,
        "longitude": 104.990963,
        "name": "Cambodia",
        "iso2": "KH",
        "slug": "cambodia"
    },
    "kiribati": {
        "country": "KI",
        "latitude": -3.370417,
        "longitude": -168.734039,
        "name": "Kiribati",
        "iso2": "KI",
        "slug": "kiribati"
    },
    "comoros": {
        "country": "KM",
        "latitude": -11.875001,
        "longitude": 43.872219,
        "name": "Comoros",
        "iso2": "KM",
        "slug": "comoros"
    },
    "saint-kitts-and-nevis": {
        "country": "KN",
        "latitude": 17.357822,
        "longitude": -62.782998,
        "name": "Saint Kitts and Nevis",
        "iso2": "KN",
        "slug": "saint-kitts-and-nevis"
    },
    "korea-north": {
        "country": "KP",
        "latitude": 40.339852,
        "longitude": 127.510093,
        "name": "North Korea",
        "iso2": "KP",
        "slug": "korea-north"
    },
    "korea-south": {
        "country": "KR",
        "latitude": 35.907757,
        "longitude": 127.766922,
        "name": "South Korea",
        "iso2": "KR",
        "slug": "korea-south"
    },
    "kuwait": {
        "country": "KW",
        "latitude": 29.31166,
        "longitude": 47.481766,
        "name": "Kuwait",
        "iso2": "KW",
        "slug": "kuwait"
    },
    "cayman-islands": {
        "country": "KY",
        "latitude": 19.513469,
        "longitude": -80.566956,
        "name": "Cayman Islands",
        "iso2": "KY",
        "slug": "cayman-islands"
    },
    "kazakhstan": {
        "country": "KZ",
        "latitude": 48.019573,
        "longitude": 66.923684,
        "name": "Kazakhstan",
        "iso2": "KZ",
        "slug": "kazakhstan"
    },
    "lao-pdr": {
        "country": "LA",
        "latitude": 19.85627,
        "longitude": 102.495496,
        "name": "Laos",
        "iso2": "LA",
        "slug": "lao-pdr"
    },
    "lebanon": {
        "country": "LB",
        "latitude": 33.854721,
        "longitude": 35.862285,
        "name": "Lebanon",
        "iso2": "LB",
        "slug": "lebanon"
    },
    "saint-lucia": {
        "country": "LC",
        "latitude": 13.909444,
        "longitude": -60.978893,
        "name": "Saint Lucia",
        "iso2": "LC",
        "slug": "saint-lucia"
    },
    "liechtenstein": {
        "country": "LI",
        "latitude": 47.166,
        "longitude": 9.555373,
        "name": "Liechtenstein",
        "iso2": "LI",
        "slug": "liechtenstein"
    },
    "sri-lanka": {
        "country": "LK",
        "latitude": 7.873054,
        "longitude": 80.771797,
        "name": "Sri Lanka",
        "iso2": "LK",
        "slug": "sri-lanka"
    },
    "liberia": {
        "country": "LR",
        "latitude": 6.428055,
        "longitude": -9.429499,
        "name": "Liberia",
        "iso2": "LR",
        "slug": "liberia"
    },
    "lesotho": {
        "country": "LS",
        "latitude": -29.609988,
        "longitude": 28.233608,
        "name": "Lesotho",
        "iso2": "LS",
        "slug": "lesotho"
    },
    "lithuania": {
        "country": "LT",
        "latitude": 55.169438,
        "longitude": 23.881275,
        "name": "Lithuania",
        "iso2": "LT",
        "slug": "lithuania"
    },
    "luxembourg": {
        "country": "LU",
        "latitude": 49.815273,
        "longitude": 6.129583,
        "name": "Luxembourg",
        "iso2": "LU",
        "slug": "luxembourg"
    },
    "latvia": {
        "country": "LV",
        "latitude": 56.879635,
        "longitude": 24.603189,
        "name": "Latvia",
        "iso2": "LV",
        "slug": "latvia"
    },
    "libya": {
        "country": "LY",
        "latitude": 26.3351,
        "longitude": 17.228331,
        "name": "Libya",
        "iso2": "LY",
        "slug": "libya"
    },
    "morocco": {
        "country": "MA",
        "latitude": 31.791702,
        "longitude": -7.09262,
        "name": "Morocco",
        "iso2": "MA",
        "slug": "morocco"
    },
    "monaco": {
        "country": "MC",
        "latitude": 43.750298,
        "longitude": 7.412841,
        "name": "Monaco",
        "iso2": "MC",
        "slug": "monaco"
    },
    "moldova": {
        "country": "MD",
        "latitude": 47.411631,
        "longitude": 28.369885,
        "name": "Moldova",
        "iso2": "MD",
        "slug": "moldova"
    },
    "montenegro": {
        "country": "ME",
        "latitude": 42.708678,
        "longitude": 19.37439,
        "name": "Montenegro",
        "iso2": "ME",
        "slug": "montenegro"
    },
    "madagascar": {
        "country": "MG",
        "latitude": -18.766947,
        "longitude": 46.869107,
        "name": "Madagascar",
        "iso2": "MG",
        "slug": "madagascar"
    },
    "marshall-islands": {
        "country": "MH",
        "latitude": 7.131474,
        "longitude": 171.184478,
        "name": "Marshall Islands",
        "iso2": "MH",
        "slug": "marshall-islands"
    },
    "macedonia": {
        "country": "MK",
        "latitude": 41.608635,
        "longitude": 21.745275,
        "name": "Macedonia [FYROM]",
        "iso2": "MK",
        "slug": "macedonia"
    },
    "mali": {
        "country": "ML",
        "latitude": 17.570692,
        "longitude": -3.996166,
        "name": "Mali",
        "iso2": "ML",
        "slug": "mali"
    },
    "myanmar": {
        "country": "MM",
        "latitude": 21.913965,
        "longitude": 95.956223,
        "name": "Myanmar [Burma]",
        "iso2": "MM",
        "slug": "myanmar"
    },
    "mongolia": {
        "country": "MN",
        "latitude": 46.862496,
        "longitude": 103.846656,
        "name": "Mongolia",
        "iso2": "MN",
        "slug": "mongolia"
    },
    "macao-sar-china": {
        "country": "MO",
        "latitude": 22.198745,
        "longitude": 113.543873,
        "name": "Macau",
        "iso2": "MO",
        "slug": "macao-sar-china"
    },
    "northern-mariana-islands": {
        "country": "MP",
        "latitude": 17.33083,
        "longitude": 145.38469,
        "name": "Northern Mariana Islands",
        "iso2": "MP",
        "slug": "northern-mariana-islands"
    },
    "martinique": {
        "country": "MQ",
        "latitude": 14.641528,
        "longitude": -61.024174,
        "name": "Martinique",
        "iso2": "MQ",
        "slug": "martinique"
    },
    "mauritania": {
        "country": "MR",
        "latitude": 21.00789,
        "longitude": -10.940835,
        "name": "Mauritania",
        "iso2": "MR",
        "slug": "mauritania"
    },
    "montserrat": {
        "country": "MS",
        "latitude": 16.742498,
        "longitude": -62.187366,
        "name": "Montserrat",
        "iso2": "MS",
        "slug": "montserrat"
    },
    "malta": {
        "country": "MT",
        "latitude": 35.937496,
        "longitude": 14.375416,
        "name": "Malta",
        "iso2": "MT",
        "slug": "malta"
    },
    "mauritius": {
        "country": "MU",
        "latitude": -20.348404,
        "longitude": 57.552152,
        "name": "Mauritius",
        "iso2": "MU",
        "slug": "mauritius"
    },
    "maldives": {
        "country": "MV",
        "latitude": 3.202778,
        "longitude": 73.22068,
        "name": "Maldives",
        "iso2": "MV",
        "slug": "maldives"
    },
    "malawi": {
        "country": "MW",
        "latitude": -13.254308,
        "longitude": 34.301525,
        "name": "Malawi",
        "iso2": "MW",
        "slug": "malawi"
    },
    "mexico": {
        "country": "MX",
        "latitude": 23.634501,
        "longitude": -102.552784,
        "name": "Mexico",
        "iso2": "MX",
        "slug": "mexico"
    },
    "malaysia": {
        "country": "MY",
        "latitude": 4.210484,
        "longitude": 101.975766,
        "name": "Malaysia",
        "iso2": "MY",
        "slug": "malaysia"
    },
    "mozambique": {
        "country": "MZ",
        "latitude": -18.665695,
        "longitude": 35.529562,
        "name": "Mozambique",
        "iso2": "MZ",
        "slug": "mozambique"
    },
    "namibia": {
        "country": "NA",
        "latitude": -22.95764,
        "longitude": 18.49041,
        "name": "Namibia",
        "iso2": "NA",
        "slug": "namibia"
    },
    "new-caledonia": {
        "country": "NC",
        "latitude": -20.904305,
        "longitude": 165.618042,
        "name": "New Caledonia",
        "iso2": "NC",
        "slug": "new-caledonia"
    },
    "niger": {
        "country": "NE",
        "latitude": 17.607789,
        "longitude": 8.081666,
        "name": "Niger",
        "iso2": "NE",
        "slug": "niger"
    },
    "norfolk-island": {
        "country": "NF",
        "latitude": -29.040835,
        "longitude": 167.954712,
        "name": "Norfolk Island",
        "iso2": "NF",
        "slug": "norfolk-island"
    },
    "nigeria": {
        "country": "NG",
        "latitude": 9.081999,
        "longitude": 8.675277,
        "name": "Nigeria",
        "iso2": "NG",
        "slug": "nigeria"
    },
    "nicaragua": {
        "country": "NI",
        "latitude": 12.865416,
        "longitude": -85.207229,
        "name": "Nicaragua",
        "iso2": "NI",
        "slug": "nicaragua"
    },
    "netherlands": {
        "country": "NL",
        "latitude": 52.132633,
        "longitude": 5.291266,
        "name": "Netherlands",
        "iso2": "NL",
        "slug": "netherlands"
    },
    "norway": {
        "country": "NO",
        "latitude": 60.472024,
        "longitude": 8.468946,
        "name": "Norway",
        "iso2": "NO",
        "slug": "norway"
    },
    "nepal": {
        "country": "NP",
        "latitude": 28.394857,
        "longitude": 84.124008,
        "name": "Nepal",
        "iso2": "NP",
        "slug": "nepal"
    },
    "nauru": {
        "country": "NR",
        "latitude": -0.522778,
        "longitude": 166.931503,
        "name": "Nauru",
        "iso2": "NR",
        "slug": "nauru"
    },
    "niue": {
        "country": "NU",
        "latitude": -19.054445,
        "longitude": -169.867233,
        "name": "Niue",
        "iso2": "NU",
        "slug": "niue"
    },
    "new-zealand": {
        "country": "NZ",
        "latitude": -40.900557,
        "longitude": 174.885971,
        "name": "New Zealand",
        "iso2": "NZ",
        "slug": "new-zealand"
    },
    "oman": {
        "country": "OM",
        "latitude": 21.512583,
        "longitude": 55.923255,
        "name": "Oman",
        "iso2": "OM",
        "slug": "oman"
    },
    "panama": {
        "country": "PA",
        "latitude": 8.537981,
        "longitude": -80.782127,
        "name": "Panama",
        "iso2": "PA",
        "slug": "panama"
    },
    "peru": {
        "country": "PE",
        "latitude": -9.189967,
        "longitude": -75.015152,
        "name": "Peru",
        "iso2": "PE",
        "slug": "peru"
    },
    "french-polynesia": {
        "country": "PF",
        "latitude": -17.679742,
        "longitude": -149.406843,
        "name": "French Polynesia",
        "iso2": "PF",
        "slug": "french-polynesia"
    },
    "papua-new-guinea": {
        "country": "PG",
        "latitude": -6.314993,
        "longitude": 143.95555,
        "name": "Papua New Guinea",
        "iso2": "PG",
        "slug": "papua-new-guinea"
    },
    "philippines": {
        "country": "PH",
        "latitude": 12.879721,
        "longitude": 121.774017,
        "name": "Philippines",
        "iso2": "PH",
        "slug": "philippines"
    },
    "pakistan": {
        "country": "PK",
        "latitude": 30.375321,
        "longitude": 69.345116,
        "name": "Pakistan",
        "iso2": "PK",
        "slug": "pakistan"
    },
    "poland": {
        "country": "PL",
        "latitude": 51.919438,
        "longitude": 19.145136,
        "name": "Poland",
        "iso2": "PL",
        "slug": "poland"
    },
    "saint-pierre-and-miquelon": {
        "country": "PM",
        "latitude": 46.941936,
        "longitude": -56.27111,
        "name": "Saint Pierre and Miquelon",
        "iso2": "PM",
        "slug": "saint-pierre-and-miquelon"
    },
    "pitcairn": {
        "country": "PN",
        "latitude": -24.703615,
        "longitude": -127.439308,
        "name": "Pitcairn Islands",
        "iso2": "PN",
        "slug": "pitcairn"
    },
    "puerto-rico": {
        "country": "PR",
        "latitude": 18.220833,
        "longitude": -66.590149,
        "name": "Puerto Rico",
        "iso2": "PR",
        "slug": "puerto-rico"
    },
    "palestine": {
        "country": "PS",
        "latitude": 31.952162,
        "longitude": 35.233154,
        "name": "Palestinian Territories",
        "iso2": "PS",
        "slug": "palestine"
    },
    "portugal": {
        "country": "PT",
        "latitude": 39.399872,
        "longitude": -8.224454,
        "name": "Portugal",
        "iso2": "PT",
        "slug": "portugal"
    },
    "palau": {
        "country": "PW",
        "latitude": 7.51498,
        "longitude": 134.58252,
        "name": "Palau",
        "iso2": "PW",
        "slug": "palau"
    },
    "paraguay": {
        "country": "PY",
        "latitude": -23.442503,
        "longitude": -58.443832,
        "name": "Paraguay",
        "iso2": "PY",
        "slug": "paraguay"
    },
    "qatar": {
        "country": "QA",
        "latitude": 25.354826,
        "longitude": 51.183884,
        "name": "Qatar",
        "iso2": "QA",
        "slug": "qatar"
    },
    "réunion": {
        "country": "RE",
        "latitude": -21.115141,
        "longitude": 55.536384,
        "name": "Réunion",
        "iso2": "RE",
        "slug": "réunion"
    },
    "romania": {
        "country": "RO",
        "latitude": 45.943161,
        "longitude": 24.96676,
        "name": "Romania",
        "iso2": "RO",
        "slug": "romania"
    },
    "serbia": {
        "country": "RS",
        "latitude": 44.016521,
        "longitude": 21.005859,
        "name": "Serbia",
        "iso2": "RS",
        "slug": "serbia"
    },
    "russia": {
        "country": "RU",
        "latitude": 61.52401,
        "longitude": 105.318756,
        "name": "Russia",
        "iso2": "RU",
        "slug": "russia"
    },
    "rwanda": {
        "country": "RW",
        "latitude": -1.940278,
        "longitude": 29.873888,
        "name": "Rwanda",
        "iso2": "RW",
        "slug": "rwanda"
    },
    "saudi-arabia": {
        "country": "SA",
        "latitude": 23.885942,
        "longitude": 45.079162,
        "name": "Saudi Arabia",
        "iso2": "SA",
        "slug": "saudi-arabia"
    },
    "solomon-islands": {
        "country": "SB",
        "latitude": -9.64571,
        "longitude": 160.156194,
        "name": "Solomon Islands",
        "iso2": "SB",
        "slug": "solomon-islands"
    },
    "seychelles": {
        "country": "SC",
        "latitude": -4.679574,
        "longitude": 55.491977,
        "name": "Seychelles",
        "iso2": "SC",
        "slug": "seychelles"
    },
    "sudan": {
        "country": "SD",
        "latitude": 12.862807,
        "longitude": 30.217636,
        "name": "Sudan",
        "iso2": "SD",
        "slug": "sudan"
    },
    "sweden": {
        "country": "SE",
        "latitude": 60.128161,
        "longitude": 18.643501,
        "name": "Sweden",
        "iso2": "SE",
        "slug": "sweden"
    },
    "singapore": {
        "country": "SG",
        "latitude": 1.352083,
        "longitude": 103.819836,
        "name": "Singapore",
        "iso2": "SG",
        "slug": "singapore"
    },
    "saint-helena": {
        "country": "SH",
        "latitude": -24.143474,
        "longitude": -10.030696,
        "name": "Saint Helena",
        "iso2": "SH",
        "slug": "saint-helena"
    },
    "slovenia": {
        "country": "SI",
        "latitude": 46.151241,
        "longitude": 14.995463,
        "name": "Slovenia",
        "iso2": "SI",
        "slug": "slovenia"
    },
    "svalbard-and-jan-mayen-islands": {
        "country": "SJ",
        "latitude": 77.553604,
        "longitude": 23.670272,
        "name": "Svalbard and Jan Mayen",
        "iso2": "SJ",
        "slug": "svalbard-and-jan-mayen-islands"
    },
    "slovakia": {
        "country": "SK",
        "latitude": 48.669026,
        "longitude": 19.699024,
        "name": "Slovakia",
        "iso2": "SK",
        "slug": "slovakia"
    },
    "sierra-leone": {
        "country": "SL",
        "latitude": 8.460555,
        "longitude": -11.779889,
        "name": "Sierra Leone",
        "iso2": "SL",
        "slug": "sierra-leone"
    },
    "san-marino": {
        "country": "SM",
        "latitude": 43.94236,
        "longitude": 12.457777,
        "name": "San Marino",
        "iso2": "SM",
        "slug": "san-marino"
    },
    "senegal": {
        "country": "SN",
        "latitude": 14.497401,
        "longitude": -14.452362,
        "name": "Senegal",
        "iso2": "SN",
        "slug": "senegal"
    },
    "somalia": {
        "country": "SO",
        "latitude": 5.152149,
        "longitude": 46.199616,
        "name": "Somalia",
        "iso2": "SO",
        "slug": "somalia"
    },
    "suriname": {
        "country": "SR",
        "latitude": 3.919305,
        "longitude": -56.027783,
        "name": "Suriname",
        "iso2": "SR",
        "slug": "suriname"
    },
    "sao-tome-and-principe": {
        "country": "ST",
        "latitude": 0.18636,
        "longitude": 6.613081,
        "name": "São Tomé and Príncipe",
        "iso2": "ST",
        "slug": "sao-tome-and-principe"
    },
    "el-salvador": {
        "country": "SV",
        "latitude": 13.794185,
        "longitude": -88.89653,
        "name": "El Salvador",
        "iso2": "SV",
        "slug": "el-salvador"
    },
    "syria": {
        "country": "SY",
        "latitude": 34.802075,
        "longitude": 38.996815,
        "name": "Syria",
        "iso2": "SY",
        "slug": "syria"
    },
    "swaziland": {
        "country": "SZ",
        "latitude": -26.522503,
        "longitude": 31.465866,
        "name": "Swaziland",
        "iso2": "SZ",
        "slug": "swaziland"
    },
    "turks-and-caicos-islands": {
        "country": "TC",
        "latitude": 21.694025,
        "longitude": -71.797928,
        "name": "Turks and Caicos Islands",
        "iso2": "TC",
        "slug": "turks-and-caicos-islands"
    },
    "chad": {
        "country": "TD",
        "latitude": 15.454166,
        "longitude": 18.732207,
        "name": "Chad",
        "iso2": "TD",
        "slug": "chad"
    },
    "french-southern-territories": {
        "country": "TF",
        "latitude": -49.280366,
        "longitude": 69.348557,
        "name": "French Southern Territories",
        "iso2": "TF",
        "slug": "french-southern-territories"
    },
    "togo": {
        "country": "TG",
        "latitude": 8.619543,
        "longitude": 0.824782,
        "name": "Togo",
        "iso2": "TG",
        "slug": "togo"
    },
    "thailand": {
        "country": "TH",
        "latitude": 15.870032,
        "longitude": 100.992541,
        "name": "Thailand",
        "iso2": "TH",
        "slug": "thailand"
    },
    "tajikistan": {
        "country": "TJ",
        "latitude": 38.861034,
        "longitude": 71.276093,
        "name": "Tajikistan",
        "iso2": "TJ",
        "slug": "tajikistan"
    },
    "tokelau": {
        "country": "TK",
        "latitude": -8.967363,
        "longitude": -171.855881,
        "name": "Tokelau",
        "iso2": "TK",
        "slug": "tokelau"
    },
    "timor-leste": {
        "country": "TL",
        "latitude": -8.874217,
        "longitude": 125.727539,
        "name": "Timor-Leste",
        "iso2": "TL",
        "slug": "timor-leste"
    },
    "turkmenistan": {
        "country": "TM",
        "latitude": 38.969719,
        "longitude": 59.556278,
        "name": "Turkmenistan",
        "iso2": "TM",
        "slug": "turkmenistan"
    },
    "tunisia": {
        "country": "TN",
        "latitude": 33.886917,
        "longitude": 9.537499,
        "name": "Tunisia",
        "iso2": "TN",
        "slug": "tunisia"
    },
    "tonga": {
        "country": "TO",
        "latitude": -21.178986,
        "longitude": -175.198242,
        "name": "Tonga",
        "iso2": "TO",
        "slug": "tonga"
    },
    "turkey": {
        "country": "TR",
        "latitude": 38.963745,
        "longitude": 35.243322,
        "name": "Turkey",
        "iso2": "TR",
        "slug": "turkey"
    },
    "trinidad-and-tobago": {
        "country": "TT",
        "latitude": 10.691803,
        "longitude": -61.222503,
        "name": "Trinidad and Tobago",
        "iso2": "TT",
        "slug": "trinidad-and-tobago"
    },
    "tuvalu": {
        "country": "TV",
        "latitude": -7.109535,
        "longitude": 177.64933,
        "name": "Tuvalu",
        "iso2": "TV",
        "slug": "tuvalu"
    },
    "taiwan": {
        "country": "TW",
        "latitude": 23.69781,
        "longitude": 120.960515,
        "name": "Taiwan",
        "iso2": "TW",
        "slug": "taiwan"
    },
    "tanzania": {
        "country": "TZ",
        "latitude": -6.369028,
        "longitude": 34.888822,
        "name": "Tanzania",
        "iso2": "TZ",
        "slug": "tanzania"
    },
    "ukraine": {
        "country": "UA",
        "latitude": 48.379433,
        "longitude": 31.16558,
        "name": "Ukraine",
        "iso2": "UA",
        "slug": "ukraine"
    },
    "uganda": {
        "country": "UG",
        "latitude": 1.373333,
        "longitude": 32.290275,
        "name": "Uganda",
        "iso2": "UG",
        "slug": "uganda"
    },
    "us-minor-outlying-islands": {
        "country": "UM",
        "latitude": "",
        "longitude": "",
        "name": "U.S. Minor Outlying Islands",
        "iso2": "UM",
        "slug": "us-minor-outlying-islands"
    },
    // "united-states": {
    //     "country": "US",
    //     "latitude": 37.09024,
    //     "longitude": -95.712891,
    //     "name": "United States",
    //     "iso2": "US",
    //     "slug": "united-states"
    // },
    "uruguay": {
        "country": "UY",
        "latitude": -32.522779,
        "longitude": -55.765835,
        "name": "Uruguay",
        "iso2": "UY",
        "slug": "uruguay"
    },
    "uzbekistan": {
        "country": "UZ",
        "latitude": 41.377491,
        "longitude": 64.585262,
        "name": "Uzbekistan",
        "iso2": "UZ",
        "slug": "uzbekistan"
    },
    "holy-see-vatican-city-state": {
        "country": "VA",
        "latitude": 41.902916,
        "longitude": 12.453389,
        "name": "Vatican City",
        "iso2": "VA",
        "slug": "holy-see-vatican-city-state"
    },
    "saint-vincent-and-the-grenadines": {
        "country": "VC",
        "latitude": 12.984305,
        "longitude": -61.287228,
        "name": "Saint Vincent and the Grenadines",
        "iso2": "VC",
        "slug": "saint-vincent-and-the-grenadines"
    },
    "venezuela": {
        "country": "VE",
        "latitude": 6.42375,
        "longitude": -66.58973,
        "name": "Venezuela",
        "iso2": "VE",
        "slug": "venezuela"
    },
    "british-virgin-islands": {
        "country": "VG",
        "latitude": 18.420695,
        "longitude": -64.639968,
        "name": "British Virgin Islands",
        "iso2": "VG",
        "slug": "british-virgin-islands"
    },
    "virgin-islands": {
        "country": "VI",
        "latitude": 18.335765,
        "longitude": -64.896335,
        "name": "U.S. Virgin Islands",
        "iso2": "VI",
        "slug": "virgin-islands"
    },
    "vietnam": {
        "country": "VN",
        "latitude": 14.058324,
        "longitude": 108.277199,
        "name": "Vietnam",
        "iso2": "VN",
        "slug": "vietnam"
    },
    "vanuatu": {
        "country": "VU",
        "latitude": -15.376706,
        "longitude": 166.959158,
        "name": "Vanuatu",
        "iso2": "VU",
        "slug": "vanuatu"
    },
    "wallis-and-futuna-islands": {
        "country": "WF",
        "latitude": -13.768752,
        "longitude": -177.156097,
        "name": "Wallis and Futuna",
        "iso2": "WF",
        "slug": "wallis-and-futuna-islands"
    },
    "samoa": {
        "country": "WS",
        "latitude": -13.759029,
        "longitude": -172.104629,
        "name": "Samoa",
        "iso2": "WS",
        "slug": "samoa"
    },
    "kosovo": {
        "country": "XK",
        "latitude": 42.602636,
        "longitude": 20.902977,
        "name": "Kosovo",
        "iso2": "XK",
        "slug": "kosovo"
    },
    "yemen": {
        "country": "YE",
        "latitude": 15.552727,
        "longitude": 48.516388,
        "name": "Yemen",
        "iso2": "YE",
        "slug": "yemen"
    },
    "mayotte": {
        "country": "YT",
        "latitude": -12.8275,
        "longitude": 45.166244,
        "name": "Mayotte",
        "iso2": "YT",
        "slug": "mayotte"
    },
    "south-africa": {
        "country": "ZA",
        "latitude": -30.559482,
        "longitude": 22.937506,
        "name": "South Africa",
        "iso2": "ZA",
        "slug": "south-africa"
    },
    "zambia": {
        "country": "ZM",
        "latitude": -13.133897,
        "longitude": 27.849332,
        "name": "Zambia",
        "iso2": "ZM",
        "slug": "zambia"
    },
    "zimbabwe": {
        "country": "ZW",
        "latitude": -19.015438,
        "longitude": 29.154857,
        "name": "Zimbabwe",
        "iso2": "ZW",
        "slug": "zimbabwe"
    },
    // "gaza-strip": {
    //     "country": "GZ",
    //     "latitude": 31.354676,
    //     "longitude": 34.308825,
    //     "name": "Gaza Strip",
    //     "iso2": "GZ",
    //     "slug": "gaza-strip"
    // }
};